var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`md-layout-item md-size-${_vm.size} md-small-size-${_vm.smallSize||_vm.size*2} md-xsmall-size-100`},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',{staticClass:"field-content"},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.value)+"\n    ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/FField.vue